export default {
  signals: 'Sygnały',
  axes: 'Siekiery',
  addAxis: 'Dodaj oś',
};
